import _ from "lodash";
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { motion, AnimatePresence } from "framer-motion";

import { GNB, GNBSub } from "src/components/Typography";
import { colors } from "src/styles/colors";

type Props = {
  className?: string;
  active?: boolean;
  menuText: React.ReactNode;
  menus: React.ReactNode[];
};

const Container = styled(motion.div)`
  position: relative;
  cursor: pointer;
`;

const MenuItemText = styled(GNB)<{ $active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  ${({ $active }) =>
    $active
      ? css`
          color: ${colors.text.dark.title};
        `
      : css`
          color: ${colors.text.dark.body};
        `}
`;

const MenuItems = styled(motion.div)`
  position: absolute;
  top: 50px;
  left: 0px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0px 2px 3px rgba(54, 62, 76, 0.1),
    0px 6px 5px rgba(54, 62, 76, 0.15), 0px 1px 10px rgba(54, 62, 76, 0.15);
  border-radius: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  z-index: 10;
`;

const MenuItem = styled(GNBSub)`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${colors.text.dark.body};
  width: 300px;
  height: 48px;
  padding-left: 12px;
  padding-right: 12px;
  cursor: pointer;
  &:hover {
    background: #fafbfc;
  }
`;

const Menus = (props: Props) => {
  const { className, menuText, menus } = props;
  const [isHovered, setHovered] = useState(false);

  return (
    <Container
      className={className}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <MenuItemText $active={isHovered}>{menuText}</MenuItemText>
      <AnimatePresence>
        {isHovered && (
          <MenuItems
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {_.map(menus, (menu, index) => {
              return <MenuItem key={`menu${index}`}>{menu}</MenuItem>;
            })}
          </MenuItems>
        )}
      </AnimatePresence>
    </Container>
  );
};

export default Menus;
